export default function hasCloseSms(acr?: string): boolean {
    return acr !== 'login:sms' && acr !== 'fullname:sms';
}
